import React, { forwardRef, Fragment, useRef } from "react";
import Styles from "./Filters.module.css";

interface FlowFilterProps {
  deliveryFlowOptions: string[];
  parentFilterInstance?: any;
}

/**
 * Dropdown filter for AgGrid "Order Flow" column.
 * Receives a list of order flow options and notifies AgGrid when the user selects a value.
 * The parentFilterInstance prop is injected by AgGrid at runtime and is used to communicate filter changes.
 */
export default forwardRef<HTMLSelectElement, FlowFilterProps>((props, ref) => {
  const inputRef = useRef<HTMLSelectElement | null>(null);

  /**
   * Notifies AgGrid to update the filter when the user selects a value.
   * parentFilterInstance is injected by AgGrid and may not be present in all contexts (e.g., during testing).
   */
  const onInputBoxChanged = (input: React.ChangeEvent<HTMLSelectElement>) => {
    props?.parentFilterInstance((instance: any) => {
      const params = {
        firstParam: null,
        secondParam: null,
      };
      const inputParams =
        input.target.value === ""
          ? params
          : { firstParam: "equals", secondParam: input.target.value };
      instance.onFloatingFilterChanged(
        inputParams.firstParam,
        inputParams.secondParam
      );
    });
  };

  return (
    <Fragment>
      <select
        ref={inputRef}
        onChange={onInputBoxChanged}
        className={Styles.selectFilter}
      >
        <option value=""></option>
        {props.deliveryFlowOptions.map((option) => (
          <option value={option} key={option}>
            {option}
          </option>
        ))}
      </select>
    </Fragment>
  );
});
